// import AuthWrapper from "@/layout/wrapper/AuthWrapper";
import React, { useEffect, useState } from "react";
import styles from "../../styles/pages/login.module.scss";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  List,
  ListItem,
  OutlinedInput,
  Paper,
  Popover,
  Stack,
  Tooltip,
  TooltipProps,
  Typography,
  Zoom,
  styled,
  tooltipClasses,
} from "@mui/material";

// import assest from "@/json/assest";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "../../ui/Icons/VisibilityOff";
import Visibility from "../../ui/Icons/Visibility";
import Alert from "@mui/material/Alert";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { useForm } from "react-hook-form";

// import useNotiStack from "@/hooks/useNotistack";

import { Link, useNavigate, useParams } from "react-router-dom";
import useNotiStack from "../../hooks/useNotistack";
import { useResetPassword } from "../../hooks/useUser";
import logo from "../../public/assets/images/logo.svg";
import iconLock from "../../public/assets/images/icon-lock.svg";

// schema
var passwordSmallRegex = new RegExp("^(?=.*[a-z])");
var passSpecialRegex = new RegExp("^(?=.*[!@#$%^&*_()])");
var passwordCapitalRegex = new RegExp("^(?=.*[A-Z])");
var passwordNumberRegex = new RegExp("^(?=.*[0-9])");

const schema = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .min(16, "Password must be at least 16 characters"),
  confpassword: yup
    .string()
    // .required("Password is required")
    .oneOf(
      [yup.ref("password")],
      "New password and confirmation do not match. Please re-enter them."
    ),
});

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    width: 226,
    padding: "6px 13px",
    boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
    borderRadius: "10px",
  },
}));

const Index = () => {
  const {
    handleSubmit,
    control,
    register,
    setValue,
    reset,
    watch,
    formState: { errors },
    formState,
  } = useForm({
    resolver: yupResolver(schema),
  });
  // const onSubmit = (data ) => console.warn(data);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [showNewPassword, setShowNewPassword] = React.useState(false);

  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);

  const handleMouseDownNewPassword = (event) => {
    event.preventDefault();
  };

  const [showNewPasswordToggle, setNewShowPasswordToggle] = useState(false);
  const [showPasswordToggle, setShowPasswordToggle] = useState(false);
  const passwordWatch = watch("password");
  const confirmPasswordWatch = watch("confpassword");

  useEffect(() => {
    if (!showNewPasswordToggle && !passwordWatch) {
      setShowPassword(false);
    }
  }, [passwordWatch, showNewPasswordToggle]);
  const navigate = useNavigate();
  useEffect(() => {
    if (!showPasswordToggle && !confirmPasswordWatch) {
      setShowNewPassword(false);
    }
  }, [confirmPasswordWatch, showPasswordToggle]);

  const { toastSuccess, toastError } = useNotiStack();

  const { mutate, isSuccess } = useResetPassword();
  const [step, setstep] = useState(false);

  const { email } = useParams();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const params = {};
  for (const [key, value] of urlParams) {
    params[key] = value;
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("reset_code", params?.reset_code);
    formData.append("email", params.email);
    formData.append("password", data?.password);
    mutate(formData, {
      onSuccess: (res) => {
        console.warn(res, "www");

        if (res?.message === "Password changed successfully") {
          navigate("/login");
        }
      },
    });
  };

  return (
    // <AuthWrapper>
    <Box className={styles.pageLogin}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <Box className={styles.panelLeft}>
              <Link to="/">
                <img src={logo} alt="img" width={140} height={29} />
              </Link>
              <Box className={styles.authContent}>
                <Typography variant="h1">Reset Your Password.</Typography>
                <Typography variant="body1">
                  For optimal security, please follow these guidelines when
                  creating your password:
                </Typography>
                <List>
                  <ListItem>At least 8 characters in length.</ListItem>
                  <ListItem>
                    Contains a mix of letters, numbers, and symbols.
                  </ListItem>
                  <ListItem>
                    Does not include easily guessable information such as your
                    name or username.
                  </ListItem>
                </List>
                <Typography variant="body1">
                  Thanks for helping make your password secure!
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={`${styles.panelRight} ${styles.forRestPass}`}>
              <Typography variant="h2">Create a New Password</Typography>
              <Box className={styles.formSec}>
                {errors.password && (
                  <Alert severity="error" className={styles.errorAlert}>
                    {errors.password.message}
                  </Alert>
                )}
                {errors.confpassword && (
                  <Alert severity="error" className={styles.errorAlert}>
                    {errors.confpassword.message}
                  </Alert>
                )}

                {/* <Alert severity="error" className={styles.errorAlert}>Email not found in our records. Please double-check and try again.</Alert> */}
                <Box className={styles.formGroup}>
                  <label>New Password</label>
                  <OutlinedInput
                    {...register("password")}
                    error={errors?.password?.message ? true : false}
                    id="outlined-adornment-password"
                    type={showPassword ? "text" : "password"}
                    onFocus={() => {
                      setNewShowPasswordToggle(true);
                    }}
                    onBlur={() => {
                      setNewShowPasswordToggle(false);
                    }}
                    endAdornment={
                      <Zoom
                        in={showNewPasswordToggle || Boolean(passwordWatch)}
                        unmountOnExit
                        mountOnEnter
                      >
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      </Zoom>
                    }
                  />
                </Box>

                <Box className={styles.formGroup}>
                  <label>Confirm New Password</label>
                  <HtmlTooltip
                    title={
                      <>
                        <Typography
                          variant="caption"
                          className={styles.toolTxt}
                        >
                          Please ensure your password complies with our{" "}
                          <strong>Password Rules</strong>.
                        </Typography>
                      </>
                    }
                    disableInteractive
                    followCursor
                  >
                    <OutlinedInput
                      {...register("confpassword")}
                      error={errors?.confpassword?.message ? true : false}
                      id="outlined-adornment-password"
                      type={showNewPassword ? "text" : "password"}
                      onFocus={() => {
                        setShowPasswordToggle(true);
                      }}
                      onBlur={() => {
                        setShowPasswordToggle(false);
                      }}
                      endAdornment={
                        <Zoom
                          in={
                            showPasswordToggle || Boolean(confirmPasswordWatch)
                          }
                          unmountOnExit
                          mountOnEnter
                        >
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowNewPassword}
                              onMouseDown={handleMouseDownNewPassword}
                              edge="end"
                            >
                              {showNewPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        </Zoom>
                      }
                    />
                  </HtmlTooltip>
                </Box>
                <Box className={styles.formGroup}>
                  <Button className={styles.btnlogin} type="submit">
                    Reset Password
                  </Button>
                </Box>
                <Box className={styles.passwordRules}>
                  <Paper
                    // style={errors ? border:"1px"}}
                    elevation={0}
                    className={errors.password ? styles.resetPassRule : ""}
                  >
                    {/* <Paper elevation={0} className={styles.resetPassRule}> */}
                    {/* <Paper elevation={0} className={errors?{className={styles.resetPassRule} :  null}}>   */}

                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                      className={styles.passHead}
                    >
                      <img src={iconLock} alt="img" width={13} height={16} />
                      <Typography variant="caption">Password Rules</Typography>
                    </Stack>
                    <List>
                      <ListItem
                        className={`${
                          passwordWatch?.length >= 16
                            ? "passwordStepComplete"
                            : ""
                        }`}
                      >
                        Minimum 16 Characters
                      </ListItem>
                      <ListItem
                        className={`${
                          passwordNumberRegex.test(passwordWatch)
                            ? "passwordStepComplete"
                            : ""
                        }`}
                      >
                        Contains Number
                      </ListItem>
                      <ListItem
                        className={`${
                          passwordSmallRegex.test(passwordWatch)
                            ? "passwordStepComplete"
                            : ""
                        }`}
                      >
                        Contains Lowercase
                      </ListItem>
                      <ListItem
                        className={`${
                          passwordCapitalRegex.test(passwordWatch)
                            ? "passwordStepComplete"
                            : ""
                        }`}
                      >
                        Contains Uppercase
                      </ListItem>
                      <ListItem
                        className={`${
                          passSpecialRegex.test(passwordWatch)
                            ? "passwordStepComplete"
                            : ""
                        }`}
                      >
                        Contains Special Character
                      </ListItem>
                    </List>
                  </Paper>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
    // </AuthWrapper>
  );
};

export default Index;
